export default "__VITE_ASSET__xLQprfGa__"